<template>
    <div class="cc-home">
        <div class="cc-sub-container">
            <div class="bg-video">
                <video
                    class="normal-video"
                    src="https://qiaojiang.bj.bcebos.com/fe/static/video/v2_banner_video_new.mp4"
                    autoplay
                    muted
                    loop
                    preload="true"
                    playsInline="true"
                    webkit-playsinline="true"
                    x-webkit-airplay="true"
                    x5-playsinline="true"
                    x5-video-player-type="h5"
                    x5-video-orientation="portraint"
                    t7-video-player-type="inline"
                ></video>
                <video
                    class="large-video"
                    src="https://qiaojiang.bj.bcebos.com/fe/static/video/v2_banner_video_5000.mp4"
                    autoplay
                    muted
                    loop
                    preload="true"
                    playsInline="true"
                    webkit-playsinline="true"
                    x-webkit-airplay="true"
                    x5-playsinline="true"
                    x5-video-player-type="h5"
                    x5-video-orientation="portraint"
                    t7-video-player-type="inline"
                ></video>
                <div
                    ref="homeCubeDom"
                    class="bg-video-cube"
                >
                    <img src="https://qiaojiang.bj.bcebos.com/fe/static/video/v2_banner_cube_4.webp">
                </div>
            </div>
            <div class="cc-main-container">
                <div class="cc-header">
                    <div class="cc-header-left">
                        <img src="../../assets/logo.png" alt="">
                    </div>
                    <div class="cc-header-right">
                        <div class="help-icon">
                            <span @click="gotoHelpDoc">
                                <veui-icon ref="helpRef" name="question-circle"/>
                            </span>
                            <veui-tooltip
                                position="bottom"
                                target="helpRef"
                                ui="reverse"
                                :hide-delay="100"
                                overlay-class="help-overlay"
                            >
                                帮助文档
                            </veui-tooltip>
                        </div>
                        <feedback/>
                        <div class="header-line"></div>
                        <veui-button
                            ui="xl"
                            class="cc-header-login"
                            @click="handleShowLoginModal()"
                        >登录</veui-button>
                    </div>
                </div>
                <div class="cc-main-content">
                    <div class="cc-main-content-left">
                        <div class="main-title">
                            <p>AIGC赋能</p>
                            <p>营销创意新纪元</p>
                        </div>
                        <div class="main-desc">
                            汇聚百度全新AI技术，提供精准、创新、引人入胜的多模态广告创意内容。
                        </div>
                    </div>
                </div>
                <div id="cc-home-login-container" ref="homeLoginDom"></div>
            </div>
        </div>
        <div>
            <cc-content
                @clickNav="handleClickNav"
                @goDetail="handleShowLoginModal"
            />
            <cc-footer/>
        </div>
    </div>
</template>

<script>
/* globals ucCommonLogin */
import {Button, Icon, Tooltip} from 'veui';
import NavContent from './components/NavContentV2.vue';
import LinkFooter from './components/LinkFooter.vue';
import passportMixinV2 from '@/mixins/passportMixinV2';
import Feedback from '@/component/Feedback';
import 'veui-theme-dls-icons/user-circle';
import 'veui-theme-dls-icons/chevron-down';

import {get as getCookie} from '@/lib/cookie';
import {APP_ID} from '@/common/config';

export default {
    name: 'login',
    inject: ['$toast', 'alsLog'],
    mixins: [passportMixinV2],
    components: {
        'veui-button': Button,
        'veui-icon': Icon,
        'veui-tooltip': Tooltip,
        'cc-content': NavContent,
        'cc-footer': LinkFooter,
        Feedback
    },
    data() {
        return {
            loading: true
        };
    },
    created() {
        // 打开登录页的时候，尝试获取一下登录信息，如果已经登录通过了的，则自动跳到登录后的首页
        const CPID = getCookie(`CPID_${APP_ID}`) || '';
        const CPTK = getCookie(`CPTK_${APP_ID}`) || '';
        const hairuo = {
            userid: CPID,
            optid: CPID,
            token: CPTK
        };
        this.$store.dispatch('getUserInfo', hairuo).then(data => {
            // 已经登录的则直接跳到登录状态之后的首页
            if (data?.accountInfo) {
                this.$router.push({
                    path: `/user/${CPID}/index`
                });
            }
        }).catch(err => {
        });
    },
    mounted() {
        this.alsLog({
            f1: 'loginPagePv',
            f2: 'show',
            f5: this.$route.name,
            f11: 'v2'
        });
    },
    methods: {
        // 点击登录按钮，打开登录的浮窗，魔方隐藏
        handleShowLoginModal(item = null) {
            window.scrollTo({
                top: 0
            });
            ucCommonLogin.show();
            this.showLoginAndHideCube();

            this.alsLog({
                f1: `${item ? 'detailButton' : 'loginButton'}`,
                f2: 'click',
                f11: `v2_button_${item ? item?.text : '登录'}`
            });
        },
        // 点击快捷跳转的菜单
        handleClickNav(item) {
            this.alsLog({
                f1: 'quickButton',
                f2: 'click',
                f11: `v2_quick_${item?.title}`
            });
        },
        gotoHelpDoc() {
            const {protocol, host} = window.location;
            const prefix = `${protocol}//${host}`;
            const firstDoc = '信息流广告标题';
            const url = `${prefix}/helpDoc/${firstDoc}`;
            this.alsLog({
                f1: 'helpDoc',
                f2: 'click',
                f5: this.$route.name,
                f15: this.$route?.path
            });
            window.open(url, '_blank', 'noreferrer');
        }
    }
};
</script>

<style lang="less" scoped>
.cc-home {
    height: auto;
    min-height: 600px;
    min-width: 1240px;
    background-image: url('./assets/v2_banner_bg.png');
    background-repeat: repeat;
    background-color: linear-gradient(#D8EDFF, #FFFFFF);
}
.cc-sub-container {
    height: 600px;
    width: 100%;
    max-width: 100vw;
    overflow: hidden;
    padding: 0 20px;
    margin: 0 auto;
    position: relative;
    .bg-video {
        margin: 0 auto;
        position: absolute;
        width: 100vw;
        height: 100%;
        overflow: hidden;
        left: 50%;
        transform: translateX(-50%);
        &-cube {
            position: absolute;
            top: 0;
            left: 50%;
            width: 700px;
            height: 600px;
            // background-image: url('https://qiaojiang.bj.bcebos.com/fe/static/video/v2_banner_cube_4.webp');
            background-size: contain;
            background-size: 105% 105%;
            background-repeat: no-repeat;
            background-position: center center;
            z-index: 99;
            transform: translateX(-50px);
            @media screen and (max-width: 1400px) {
                left: unset;
                right: 0;
            }
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
    video {
        width: 100%;
        height: 100%;
        object-fit: cover;
        &.large-video {
            visibility: hidden;
            width: auto;
            max-width: unset;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
        @media screen and (min-width: 1920px) {
            &.normal-video {
                visibility: hidden;
            }
            &.large-video {
                visibility: visible;
            }
        }
    }
}
#cc-home-login-container {
    position: absolute;
    top: 120px;
    right: 0;
}
.cc-main-container {
    width: 1200px;
    margin: 0 auto;
    padding-top: 22px;
    position: relative;
    .cc-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        &-left {
            img {
                height: 24px;
            }
        }
        &-right {
            display: flex;
            align-items: center;
            gap: 16px;
        }
        &-login {
            color: #fff;
            background: linear-gradient(270deg, #3434F4 0.3%, #4C79FF 99.35%);
            border-radius: 38px;
            padding: 9px 25px;
            font-weight: 500;
            font-size: 16px;
            border: none;
            &.login-passport {
                border: 1px solid #FFF;
                background: rgba(229, 238, 255, 0.50);
                /deep/ span {
                    background: var(--AI-, linear-gradient(271deg, #3434F4 0.3%, #4C79FF 99.35%));
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
            }
        }
        .header-line {
            height: 18px;
            width: 1px;
            opacity: 0.3;
            background: var(----G0, #FFF);
            background: linear-gradient(270deg, #3434F4 0.3%, #4C79FF 99.35%);
        }
    }
    .cc-main-content {
        display: flex;
        &-left {
            margin-top: 105px;
            width: 536px;
            .main-title {
                font-style: normal;
                font-weight: 600;
                font-size: 60px;
                line-height: 75px;
                color: #000000;
            }
            .main-desc {
                font-style: normal;
                font-weight: 400;
                font-size: 24px;
                line-height: 36px;
                color: #282C33;
                margin-top: 24px;
            }
        }
    }

}

.help-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    cursor: pointer;
    &:hover {
        color: #545B66;
    }
}
.help-overlay {
    /deep/ .veui-tooltip {
        border-radius: var(--Radius-r1, 6px);
        background: var(----G9, #282C33);
        margin-top: 6px;
        padding: 0 8px;
        height: 25px;
    }
    /deep/ .veui-tooltip-content {
        margin: 0px;
        color: var(----G0, #FFF);
        display: inline-flex;
        height: 100%;
        align-items: center;
    }
    /deep/ .veui-tooltip-arrow {
        color: var(----G9, #282C33);
    }
}
</style>
